import React, { useEffect, useState } from "react";

import SelectField from "../../../library/components/Select/index";
import { useGetEpbdownloadingPhaseWiseNodalReportMutation,useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
// import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"

import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State Name",
  "Total e-Pb and PIN Transmitted",
  "Total e-PB Downloaded",
  "Total e-Pb PIN Downloaded",
];

const phaseList = [
  { value: "", label: "Select Phase" },
];

const EpbDownloadingPhasewise = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Downloading Report Phase Wise ( State Wise )"
  const SheetName = "State Wise Report"

  const [Error, setError] = useState({});
  const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [tableData, setTableData] = useState([]);
  // const stateList = [{value: "", label: " Select State" }];
  // const constType = [
  //   { value: "", label: "Select Constituency" },
  //   { value: "AC", label: "AC" },
  //   { value: "PC", label: "PC" },
  // ];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "Total e-Pb and PIN Transmitted",
      accessor: "col2",
    },
    {
      Header: "Total e-Pb Downloaded",
      accessor: "col3",
    },
    {
      Header: "Total e-Pb PIN Downloaded",
      accessor: "col4",
    },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })
  const [states, setStates] = useState({
    phaseNo:"",
    constTypeValue:"",
  });

  const [saveData, datap] = useGetEpbdownloadingPhaseWiseNodalReportMutation()

  // getElectionAnnouncedState?.payload?.map((item) => {
  //   stateList?.push({
  //     value: item.stateCd,
  //     label: item.stateName,
  //   });
  // });

  useEffect(()=>{
    const Phases = JSON.parse(localStorage?.phaseList)
    Phases.map((item)=>{
     phaseList.push({value:item, label:item})
    })
 
   },[])

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const renderTableData = () => {
    let error = {};
    if (!states.phaseNo || states.phaseNo === "" || states.phaseNo.length == 0) {
      error["phaseNo"] = "This Field is required"
    }
 
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    let payload = {
      "phaseNo": states.phaseNo,
      // "constType": states.constTypeValue
    }
    saveData(payload)
      .unwrap()
      .then((res) => {
        let tData = []
        res?.payload?.map((item) => {
          tData.push({
            "col1": item.stateName,
            "col2": item.total_transmitted,
            "col3": item.total_epbDownloaded,
            "col4": item.total_epbPinDownloaded,
          });
        });
        setTableData(tData)
        setTotalNoOfRecords(res?.payload?.length)
      }).catch((error) => {
        if(error?.data?.message==="No record found")
        {
          
          setTableData([])
        }
      })
  };
  return (
    <>
    <LeftMenu>
      <div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={reportName}
            onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData , false, true)}
            onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)}
            />
          </div>
        </div>
        <div className="row">
          <SelectField
          labelClass=""
          inputClass="col-md-4"
          options={phaseList}
          name="phaseNo"
          value={states.phaseNo}
          handleChange={(val) => handleChange("phaseNo", val)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            }
          ]}

          getError={(val) => getError("phaseNo", val)}
          Error={Error}
        ></SelectField>
          {/* <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            value={states.constTypeValue}
            name="constTypeValue"
            handleChange={(val) => handleChange("constTypeValue", val)}
            options={constType}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
  
            getError={(val) => getError("constTypeValue", val)}
            Error={Error}
          /> */}
          <div className="col-md-2 ">
          <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
          </div>
        </div>
        <div style={{marginTop:"-40px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              emptyMessage="No Record Found"
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination  
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
      </div>
      </LeftMenu>
    </>
  );
};

export default EpbDownloadingPhasewise;
